import { Button, theme } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

const IconWrapper = styled.span`
  display: inline-block;
  color: black;
  width: ${theme.space[6]};
  height: ${theme.space[6]};
`;

const Icon = styled.svg`
  width: 100%;
  height: 100%;
  display: block;
  color: currentColor;

  * {
    color: inherit;
    fill: currentColor;
  }
`;

export interface Props extends Omit<
  React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
  'ref'
> {
  altText?: string;
  onClick: (e: React.MouseEvent) => void;
  title?: string;
}

const BackLink: React.FC<React.PropsWithChildren<Props>> = ({ title = 'Back', altText = 'Navigate back', onClick }) => (
  <Button m="0" p="0" variant="tertiary" onClick={onClick} tabIndex={0} title={title}>
    <IconWrapper>
      <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-label={altText} role="img">
        <title>{altText}</title>
        <polygon points="12.407 14.586 5.824 8.003 12.401 1.413 10.984 0 2.997 8.003 10.993 16" />
      </Icon>
    </IconWrapper>
  </Button>
);

export default BackLink;
